import { computed } from 'vue'
import { dblcUiTranslations } from '@ai/ui-components/translations'

export type LocaleMessages = Record<string, Record<string, string>>

export const useMergedTranslations = (localMessages?: Partial<LocaleMessages>) => {
  const mergedMessages = computed<LocaleMessages>(() => {
    const merged: LocaleMessages = {}

    const locales = new Set([
      ...Object.keys(dblcUiTranslations),
      ...Object.keys(localMessages ?? {}),
    ])

    locales.forEach((locale) => {
      merged[locale] = {
        ...((dblcUiTranslations[locale] as Record<string, string> | undefined) ?? {}),
        ...(localMessages?.[locale] ?? {}),
      }
    })

    return merged
  })

  return { mergedMessages }
}
